import type { FC } from "react";

import { serverPublishDraftPublication } from "api/api-server-publishing";
import { t } from "i18n/i18n";
import { ConfirmationDialog } from "mds/components/ConfirmationDialog";
import { useAppSelector } from "store/index";
import { selectCurrentTermTitle, selectLinkedSectionIdsForCurrentSection } from "store/selectors";
import { useCountSelector } from "store/store-hooks";
import { toastErrorMessage } from "utils/alerts";

interface PublishConfirmationDialogProps {
  open: boolean;
  publicationId: string;
  onClose: () => void;
}

export const PublishConfirmationDialog: FC<PublishConfirmationDialogProps> = ({
  open,
  publicationId,
  onClose,
}) => {
  const linkedSectionCount = useCountSelector(selectLinkedSectionIdsForCurrentSection);
  const termTitle = useAppSelector(selectCurrentTermTitle);

  const onConfirm = async () => {
    try {
      await serverPublishDraftPublication(publicationId);
    } catch {
      toastErrorMessage(t("publishing.publish_error"));
    }
  };

  return (
    <ConfirmationDialog
      confirmButtonText={t("publishing.publish_changes")}
      open={open}
      title={t("publishing.publish_template_title")}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <p>
        {t("publishing.publish_template_linked_sections", {
          count: linkedSectionCount,
          term: termTitle,
        })}
      </p>
    </ConfirmationDialog>
  );
};
